/**
 * TODO: Отрефакторить маршруты: устранить атрибут `meta.layout`. Актуальный формат можно посмотреть на примере маршрута `/open
 * `
 */

import {createMemoryHistory, createRouter, createWebHistory} from 'vue-router'
import store from '../store'
import * as Sentry from "@sentry/vue"
import {checkSentry} from "@/script"
import {hitMyTrackerMetric} from '@/script/myTrackerMetric'
import {getValidToken} from "@/script/storageToken";


const routes = [
    {
        path: '/',
        redirect: { name: 'Home' }
    },
    {
        path: '/auth',
        name: 'Auth',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/index.vue'),
        meta: {
            layout: 'auth-layout',
            guest: true
        },
        beforeEnter (to, from, next) {
            if (from.fullPath !== '/' && !from.fullPath.startsWith('/auth')) {
                localStorage.setItem('urlToNavAfterLogin', from.fullPath)
                store.commit('setUrlToNavAfterLogin', from.fullPath)
            }

            next()
        }
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import(/* webpackChunkName: "courses" */ '@/views/home/index.vue'),
        meta: {
            layout: 'inner-layout',
            requiresAuth: true,
        }
    },
    {
        path: '/printcontract',
        name: 'PrintContract',
        component: () => import('@/views/sale/PrintContract.vue'),
        meta: {
            layout: 'inner-layout',
            requiresAuth: true,
        },
    },
    {
        path: '/conveyor',
        name: 'Conveyor',
        component: () => import('@/views/conveyor.vue'),
        meta: {
            layout: 'inner-layout',
            requiresAuth: true,
        },
    },
    {
        path: '/docs',
        name: 'Docs',
        component: () => import('@/views/docs/index.vue'),
        meta: {
            layout: 'docs-layout',
            requiresAuth: false,
        },
    },
    {
        path: '/auth/reset-password/:resetToken?',
        name: 'ForgotAuth',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/index.vue'),
        meta: {
            layout: 'auth-layout',
            guest: true
        }
    },
    {
        path: '/auth/confirm/',
        name: 'ConfirmAuth',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/index.vue'),
        meta: {
            layout: 'auth-layout',
            guest: true
        }
    },
    {
        path: '/auth/signup',
        name: 'AuthSignUp',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/index.vue'),
        meta: {
            is_signup: true,
            guest: true,
            layout: 'auth-layout'
        }
    },

    // Auth routes
    {
        path: '/profile/:userId?',
        name: 'UserProfile',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/profile/index.vue'),
        meta: {
            layout: 'inner-layout',
            requiresAuth: true,
            breadcrumbs: [
                {
                    path: 'profile',
                    title: 'Профиль'
                }
            ]
        },
        props: true
    },

    {
        path: '/courses',
        name: 'Courses',
        component: () => import(/* webpackChunkName: "courses" */ '@/views/courses/index.vue'),
        meta: {
            layout: 'inner-layout',
            requiresAuth: true,
            breadcrumbs: [{
                title: 'Каталог курсов',
                path: '/courses'
            }]
        }
    },

    {
        path: '/cabinet',
        name: 'Schedule',
        component: () => import(/* webpackChunkName: "schedule" */ '@/views/schedule/index.vue'),
        meta: {
            layout: 'inner-layout',
            requiresAuth: true,
            breadcrumbs: [{
                title: 'Личный кабинет',
                path: '/cabinet'
            }]
        }
    },

    {
        path: '/badge/:hash',
        name: 'Badge',
        component: () => import(/* webpackChunkName: "search" */ '@/views/badge/index.vue'),
        meta: {
            layout: 'inner-layout',
            requiresAuth: true
        }
    },

    {
        path: '/search',
        name: 'Search',
        component: () => import(/* webpackChunkName: "search" */ '@/views/search/index.vue'),
        meta: {
            layout: 'inner-layout',
            requiresAuth: true
        }
    },

    {
        path: '/calendar',
        name: 'Homework',
        component: () => import(/* webpackChunkName: "homework" */ '@/views/calendar/index.vue'),
        meta: {
            layout: 'inner-layout',
            requiresAuth: true
        }
    },
    {
        path: '/viewcourse/:courseId',
        name: 'ViewCourse',
        component: () => import(/* webpackChunkName: "course" */ '@/views/course/innerCoursePage.vue'),
        meta: {
            layout: 'inner-layout',
            requiresAuth: false
        },
        beforeEnter: (to, from, next) => {
            if (getValidToken()) {
                next(`/course/${to.params.courseId}`)
            } else {
                next('/auth')
            }
        },
        children: [
            {
                path: '',
                name: 'ViewCourseInner',
                component: () => import(/* webpackChunkName: "course" */ '@/views/course/index.vue'),
                meta: {
                    requiresAuth: false
                },
            }
        ]
    },
    {
        path: '/course/:courseId',
        name: 'CourseInner',
        component: () => import(/* webpackChunkName: "course" */ '@/views/course/innerCoursePage.vue'),
        meta: {
            layout: 'inner-layout',
            requiresAuth: true,
        },
        props: true,
        children: [
            {
                path: '',
                name: 'Course',
                component: () => import(/* webpackChunkName: "course" */ '@/views/course/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                },
            },
            {
                path: 'glossary/:glossaryId',
                name: 'Glossary',
                component: () => import('@/views/glossary/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                },
            },
            {
                path: 'job/:jobId',
                name: 'Job',
                component: () => import('@/views/essay/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                },
            },
            {
                path: 'folder/:folderId',
                name: 'Folder',
                component: () => import('@/views/folder/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                },
            },
            {
                path: 'url/:urlId',
                name: 'Url',
                component: () => import('@/views/link/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                },
            },
            {
                path: 'module/:moduleId',
                name: 'Module',
                component: () => import('@/views/module/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                },
            },
            {
                path: 'resource/:resourceId',
                name: 'Resource',
                component: () => import('@/views/file/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                },
            },
            {
                path: 'wiki/:wikiId',
                name: 'Wiki',
                component: () => import('@/views/wiki/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                },
            },
            {
                path: 'badges',
                name: 'CourseBadges',
                component: () => import('@/views/badges/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                },
            },
            {
                path: 'forum/:forumId',
                name: 'Forum',
                component: () => import('@/views/forum/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                },
            },
            {
                path: 'forum/:forumId/discuss/:discussId',
                name: 'Discuss',
                component: () => import('@/views/forum/discuss.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                },
            },
            {
                path: 'page/:pageId',
                name: "Page",
                component: () => import('@/views/page/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true
                }
            },
            {
                path: 'book/:bookId',
                name: "Book",
                component: () => import('@/views/book/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true
                }
            },
            {
                path: 'feedback/:feedbackId',
                name: 'Feedback',
                component: () => import('@/views/feedback/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                },
            },
            {
                path: 'grades',
                name: 'GradesDetails',
                component: () => import(/* webpackChunkName: "courses" */ '@/views/ratingDetails/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                }
            },
            {
                path: 'quiz/:quizId',
                name: 'Quiz',
                component: () => import(/* webpackChunkName: "courseList" */ '@/views/quiz/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                },
                props: true,
            },
            {
                path: 'quiz/:quizId/attempt/:attemptId',
                name: 'QuizAttempt',
                component: () => import('@/views/quiz/pages/attempt.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                },
            },
            {
                path: 'quiz/:quizId/review/:attemptId',
                name: 'QuizReview',
                component: () => import('@/views/quiz/pages/review.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                },
            },
            {
                path: 'scorm/:scormId',
                name: 'Scorm',
                component: () => import('@/views/scorm/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true,
                },
            },
            {
                path: 'members',
                name: 'Members',
                component: () => import('@/views/members/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true
                }
            },
            {
                path: 'assign/:assignId',
                name: 'Assignment',
                component: () => import('@/views/assignment/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true
                }
            },
            {
                path: 'yandexchat/:yandexchatId',
                name: 'YandexChat',
                component: () => import('@/views/yandexchat/index.vue'),
                meta: {
                    layout: 'inner-layout',
                    requiresAuth: true
                }
            }
        ]
    },

    {
        path: '/rating-details',
        name: 'RatingDetails',
        component: () => import(/* webpackChunkName: "courses" */ '@/views/ratingDetails/index.vue'),
        meta: {
            layout: 'inner-layout',
            requiresAuth: true,
        }
    },

    {
        path: '/courses-list/:catId',
        name: 'CourseList',
        component: () => import(/* webpackChunkName: "courseList" */ '@/views/courseList/index.vue'),
        meta: {
            layout: 'course-list',
            requiresAuth: true
        }
    },
    {
        path: '/rating',
        name: 'Grades',
        component: () => import(/* webpackChunkName: "courseList" */ '@/views/rating/index.vue'),
        meta: {
            layout: 'inner-layout',
            requiresAuth: true,
        },
        props: true,
    },
    {
        path: '/badges',
        name: 'UserBadges',
        component: () => import('@/views/badges/index.vue'),
        meta: {
            layout: 'inner-layout',
            requiresAuth: true,
        }
    },

    /**
     * Open UTMN showcase routes
     */
    {
        path: '/open/:pathMatch(.*)*',
        redirect: (to) => {
            const newPath = to.params.pathMatch ? '/' + to.params.pathMatch.join('/') : ''

            window.location.href = `https://open.utmn.ru${newPath}${to.hash || ''}`
        }
    },

    // Site maintenance router
    {   path: '/siteMaintenance',
        component: () => import('@/views/siteMaintenance/index.vue'),
        meta: {
            layout: 'inner-layout',
            requiresAuth: false,
        },
    },
    // Site maintenance router
    {
        path: '/siteUpdating',
        component: () => import('@/views/siteMaintenance/update.vue'),
        meta: {
            layout: 'inner-layout',
            requiresAuth: false,
        },
    },

    // ** Always leave this as last one **
    {
        path: '/:catchAll(.*)*',
        component: () => import('@/layout/empty.vue'),
        children: [
            { name: '404', path: '', component: () => import('@/views/error/404.vue') }
        ]
    }
]

const history = typeof window === 'undefined'
    ? createMemoryHistory(import.meta.env.BASE_URL)
    : createWebHistory(import.meta.env.BASE_URL)

const router = createRouter({
    history,
    routes
})

router.beforeEach((to, from, next) => {
    hitMyTrackerMetric()

    if (checkSentry()) {
        Sentry.setTag("currentPath", to.name)

        if (to.params.courseId) {
            Sentry.setTag("course.id", to.params.courseId)
        }
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {

        if (getValidToken()) {
            next()
            return
        }

        // if (to.name === 'Course') {
        //     next(`/viewcourse/${to.params.courseId}`)
        //     return
        // }

        localStorage.setItem("urlToNavAfterLogin", to.fullPath)
        store.commit("setUrlToNavAfterLogin", to.fullPath)

        Sentry.endSession()
        Sentry.startSession()
        Sentry.setTag("currentPath", 'Auth')
        next('/auth')
    } else {
        next()
    }
})

export default router
